import React, { useEffect } from 'react';
import { createPortal } from 'react-dom';
import { useContactRepBehaviour } from '../../hooks';
import { ContactRepModalView } from '../ContactRepModalView';

export const ContactRepModal = () => {
  const { modalDetails, isModalOpen, setIsModalOpen } =
    useContactRepBehaviour();
  // TODO: refactor without type assertion, or add comment
  // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
  const portalTarget = modalDetails?.portalTarget as HTMLElement;
  const [modalElement, setModalElement] =
    React.useState<React.ReactElement | null>(null);

  useEffect(() => {
    if (portalTarget) {
      setModalElement(
        createPortal(
          <ContactRepModalView
            isOpen={isModalOpen}
            setIsOpen={setIsModalOpen}
            modalDetails={modalDetails}
          />,
          portalTarget,
        ),
      );
    }
    return () => {
      if (portalTarget) {
        setModalElement(null);
      }
    };
  }, [portalTarget, isModalOpen, setIsModalOpen, modalDetails]);

  return modalElement;
};
